import {CreationAttribute} from 'src/modules/event-create/typedefs';

export const filterDecorationTemplate = (
    decorationTemplate: CreationAttribute[],
    allAttributes: CreationAttribute[],
): CreationAttribute[] => decorationTemplate.filter(attributeTemplate =>
    !allAttributes.some(attribute => attribute.name === attributeTemplate.name));
